import React, { useState } from "react";
import { useThemeClasses } from "../../hooks/useThemeClasses";

const SeoSection = () => {
  const [showMore, setShowMore] = useState(false);
  const { isDark, sc } = useThemeClasses();

  return (
    <section className={sc("seoSection")}>
      <div
        className={`transition-all duration-500 ease-in-out ${
          showMore ? "max-h-full" : "max-h-[220px] sm:max-h-[280px] overflow-hidden"
        }`}
      >
        <div
          className={`space-y-4 leading-relaxed text-sm sm:text-base ${
            isDark ? "text-slate-400" : "text-slate-600"
          }`}
        >
          <h2 className={`text-lg sm:text-xl font-bold ${isDark ? "text-white" : "text-slate-900"}`}>
            SparePe — online marketplace for car spare parts in India
          </h2>
          <p>
            Browse genuine OEM, trusted aftermarket, and inspected used parts for
            popular makes and models. Select your vehicle above, pick a part type,
            then filter by brand, price, warranty, and availability in the sidebar.
          </p>

          <h3 className={`text-base font-semibold ${isDark ? "text-slate-200" : "text-slate-800"}`}>
            How to shop
          </h3>
          <ul className="list-disc list-inside ml-1 space-y-1 text-sm">
            <li>Choose New, OEM, Aftermarket, or Used.</li>
            <li>Select your vehicle make, model, and year.</li>
            <li>Open a category to see matching listings.</li>
            <li>Use filters for brand, price range, stock, and delivery.</li>
          </ul>

          {showMore && (
            <>
              <h3 className={`text-base font-semibold ${isDark ? "text-slate-200" : "text-slate-800"}`}>
                Why SparePe
              </h3>
              <ul className="list-disc list-inside ml-1 space-y-1 text-sm">
                <li>Wide catalogue across major automotive brands.</li>
                <li>Search and filters built for quick part discovery.</li>
                <li>Pan-India fulfilment with seller-backed listings.</li>
                <li>Support for individual buyers, workshops, and fleets.</li>
              </ul>
            </>
          )}
        </div>
      </div>

      <div className="flex justify-center mt-5">
        <button type="button" onClick={() => setShowMore(!showMore)} className={sc("secondaryBtn")}>
          {showMore ? "View Less" : "View More"}
        </button>
      </div>
    </section>
  );
};

export default SeoSection;
